const initialState = {
  error: null,
  isError: false,
  isLoading: false,
  searchQuery: {

  },
  searchResults: [],
  pagination: {
      total: undefined,
      limit: undefined,
      nextPage: undefined,
      prevPage: undefined,
      totalPages: undefined,
      page: undefined,
      pagingCounter: undefined,
  },
  filterQuery: {},
  filteredResults: [],
  sortingOption:[],

};

export default initialState;
